<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    style="overflow: hidden !important"
  >
    <v-card>
      <v-card-title>
        {{
          bankParameters.length == 0
            ? `${bankParameter.name} Parametre Oluştur`
            : `${bankParameter.name} Parametre Düzenle`
        }}
        <v-spacer></v-spacer>
        <v-btn
          class="mr-5"
          v-if="bankParameters.length > 0"
          @click="deleteParameter()"
          style="background-color: gainsboro"
        >
          PARAMETREYİ SİL
        </v-btn>
        <v-btn
          @click="closeDialog()"
          color="danger darken-1"
          style="color: white"
        >
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
            <div class="col-lg-6" v-for="item in newInput" :key="item.key">
              <span class="fs-4 fw-bold">{{ item.label }}</span>
              <v-text-field
                v-if="item.key !== 'isDefault'"
                class="mt-2"
                solo
                filled
                dense
                v-model="item.value"
              ></v-text-field>
              <v-select
                class="mt-2"
                v-else
                v-model="item.value"
                :items="[
                  { value: '1', text: 'Evet' },
                  { value: '0', text: 'Hayır' },
                ]"
                item-text="text"
                item-value="value"
                dense
                filled
                solo
                placeholder=" "
                clearable
                hide-details
              >
              </v-select>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="closeDialog()">İptal</v-btn>
        <v-btn text color="success" @click="saveForm">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMessages } from "@/validationMessages.js";

import { mapActions, mapState } from "vuex";
//import simplebar from "simplebar-vue";

export default {
  components: {
    //  simplebar
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    bankParameterProp: {
      type: Object,
      default: () => ({
        id: null,
        bankCode: null,
        isActive: false,
        parameterInfoKey: [],
        parameterInfoValue: [],
        parameters: [],
        name: "",
      }),
    },
    processType: {
      type: String,
      default: "new",
    },
  },
  computed: {
    ...mapState("bank", ["bankList", "bankParameterInputs", "bankParameters"]),
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      dialog: false,
      showPassword: false,
      newInput: [],
      bankParameter: {
        id: null,
        bankCode: null,
        isActive: false,
        parameterInfoKey: [],
        parameterInfoValue: [],
        parameters: [],
        name: "",
      },
    };
  },
  methods: {
    ...mapActions("bank", [
      "fetchBankList",
      "fetchBankParameters",
      "bankParameterUpdate",
      "bankParameterAdd",
      "bankParameterDelete",
      "removeBankParameters",
    ]),
    validationMessages,
    closeDialog() {
      this.newInput = [];
      this.dialog = false;
    },
    async deleteParameter() {
      await this.bankParameterDelete({
        params: this.bankParameter.id,
      });
      this.closeDialog();
    },
    async initializeNewInput() {
      for (let i = 0; i < this.bankParameter.parameterInfoKey.length; i++) {
        let anan = this.bankParameters.find(
          (e) => e.key === this.bankParameter.parameterInfoKey[i]
        );
        this.newInput.push({
          key: this.bankParameter.parameterInfoKey[i],
          label: this.bankParameter.parameterInfoValue[i],
          value: anan ? anan.value : "", // Ensure anan is defined
        });
      }
    },
    async saveForm() {
      if (this.bankParameters.length < 1) {
        let parameters = {};
        for (let i = 0; i < this.newInput.length; i++) {
          let input = this.newInput[i];
          parameters[input.key] = input.value;
        }

        await this.bankParameterAdd({
          body: {
            bankId: this.bankParameter.id,
            parameters: parameters,
          },
        });
      } else {
        let parameters = {};
        for (let i = 0; i < this.newInput.length; i++) {
          let input = this.newInput[i];
          parameters[input.key] = input.value;
        }

        await this.bankParameterUpdate({
          body: {
            bankId: this.bankParameter.id,
            parameters: parameters,
          },
        });
      }

      this.closeDialog();
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: async function (newVal) {
      if (newVal) {
        this.removeBankParameters();
        if (this.bankParameterProp) {
          this.bankParameter = Object.assign({}, this.bankParameterProp);
          try {
            await this.fetchBankParameters(this.bankParameterProp.id);
          } catch (error) {
            error;
            this.bankParameter.parameters = [];
          }
        } else {
          this.bankParameter = {
            id: null,
            bankCode: null,
            isActive: false,
            parameterInfoKey: [],
            parameterInfoValue: [],
            parameters: [],
            name: "",
          };
        }
        await this.initializeNewInput();
      }
      this.dialog = newVal;
    },
  },
};
</script>
